export interface VehicleStorageServiceData {
    // ZoneId?: string;
    // FinishZoneId?: string;
    // ProductId?: string;
    OriginAddress: string | undefined;
    OriginAddressDetails: string | undefined;
    OriginContactName: string | undefined;
    OriginContactPhoneNumber: string | undefined;
    OriginContactEmailAddress: string | undefined;
    IsOriginContactExternal: boolean;
    OriginAddressLatitude: number;
    OriginAddressLongitude: number;
    DestinationAddress: string | undefined;
    DestinationAddressDetails: string | undefined;
    DestinationContactName: string | undefined;
    DestinationContactPhoneNumber: string | undefined;
    DestinationContactEmailAddress: string | undefined;
    IsDestinationContactExternal: boolean;
    DestinationAddressLatitude: number;
    DestinationAddressLongitude: number;
    LicensePlate: string[];
    VehicleChassisType?: number;
    VehicleFuelType?: number;
    VehicleBrand: string;
    VehicleModel: string;
    ServiceStartDate: string;
    ServiceEndDate?: string;
    Comments: string;
    BillingAddress?: BillingAddress;
    Tags: Tag[];
    pdfFileIds?: string[];
    ServiceConfiguration: ServiceConfiguration;
}

export interface BillingAddress {
    InternalIdentifier: string;
    FiscalCode: string;
    DisplayName: string;
}

export interface Tag {
    Id?: string;
    Tag?: string;
}

export interface ServiceConfiguration {
    ProductType: number;
    StartDate: string;
    VehicleStorageId: string;
    VehicleStorageName: string;
}

export enum LocationType {
    Inside = 1,
    Outside = 2,
}

export interface VehicleStorage {
    Id: string;
    Name: string;
    Address: string;
    IsCover: boolean;
    InitialPrice: number;
    PerDayPrice: number;
    ExtraPrice: number;
    City: string;
    Coordinates: string;
    Latitude?: number;
    Longitude?: number;
}